import React from 'react';
import NewsIconWrapper from './NewsIconWrapper';

export default function OfferPause(props) {
  return (
    <NewsIconWrapper {...props}>
      <circle cx="16" cy="16" r="16" fill="#FAD6B7"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M6 16C6 10.48 10.48 6 16 6C21.52 6 26 10.48 26 16C26 21.52 21.52 26 16 26C10.48 26 6 21.52 6 16ZM15 20H13V12H15V20ZM16 24C11.59 24 8 20.41 8 16C8 11.59 11.59 8 16 8C20.41 8 24 11.59 24 16C24 20.41 20.41 24 16 24ZM19 20H17V12H19V20Z" fill="black" fillOpacity="0.54"/>
    </NewsIconWrapper>
  );
}
